import React, { useLayoutEffect } from 'react';
import { View, TouchableHighlight, } from 'react-native';
import Animated from 'react-native-reanimated';
import Text from 'design-system/Text';
import StatusBar from 'design-system/StatusBar';
import ListEmptyView from 'design-system/ListEmptyView';
import { rem, IconArrow, Spacer, AppView } from 'design-system';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { formatAddress } from 'utils';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import { useFindMyAddress } from 'hooks';
import createStyleSheets from 'utils/createStyleSheets';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import ListLoader from 'design-system/ListLoader';
import { isWeb } from '../../../constants';
const strings = {
    headerTitle: 'Choose your address',
    noAddressFound: 'No address found',
};
export const AddressRowItem = React.memo(({ address, onPress, withArrow, ...props }) => {
    const title = [address.subBuildingName, address.buildingName]
        .filter(Boolean)
        .join(', ');
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<TouchableHighlight {...props} onPress={() => onPress?.(address)} underlayColor={colors.background.underlay} activeOpacity={1}>
        <View style={styles.rowItem}>
          <View style={styles.flex}>
            <Text Text-16>{title || `${formatAddress(address)}`}</Text>
            {Boolean(title) && (<Text TextThin-14 numberOfLines={1}>{`${formatAddress(address)}`}</Text>)}
          </View>
          {withArrow ? (<>
              <Spacer w={16}/>
              <IconArrow />
            </>) : null}
        </View>
      </TouchableHighlight>);
});
const ItemSeparator = () => {
    const styles = useStyles(styleSet);
    return <View style={styles.separator}/>;
};
export const FindMyAddressScreen = withAnimatedNavigationHeader(({ route, scrollHandler, navigation, navigation: { goBack } }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const { sortedAddresses = [], isFetching } = useFindMyAddress(route.params?.postcode);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    if (isFetching) {
        return (<AppView type="primary">
            <StatusBar barStyle="dark-content" animated/>
            <ListLoader />
          </AppView>);
    }
    return (<AppView type="primary" withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          {sortedAddresses.length ? (<Animated.FlatList data={sortedAddresses} scrollEventThrottle={16} onScroll={scrollHandler} showsVerticalScrollIndicator={false} ItemSeparatorComponent={ItemSeparator} contentContainerStyle={contentContainerStyle} renderItem={({ item: address }) => (<AddressRowItem address={address} onPress={() => {
                    const onAddressSelected = route.params?.onAddressSelected;
                    onAddressSelected(address);
                    goBack();
                }}/>)}/>) : (<ListEmptyView subTitle={strings.noAddressFound}/>)}
        </AppView>);
}, ({ colors }) => ({
    title: strings.headerTitle,
    headerColorOutputRange: [
        colors.background.light,
        colors.cards.onDark,
    ],
}));
const styleSet = createStyleSheets((colors) => ({
    rowItem: {
        flex: 1,
        minHeight: rem(79),
        paddingTop: rem(12),
        paddingLeft: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: rem(16),
        paddingBottom: rem(12),
        justifyContent: 'center',
    },
    separator: {
        height: rem(1),
        marginLeft: rem(16),
        backgroundColor: colors.background.dark,
    },
    flex: {
        flex: 1,
    },
}));
